"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuContext = exports.MenuContext = void 0;
var React = require("react");
exports.MenuContext = React.createContext({});
var useMenuContext = function () {
    return React.useContext(exports.MenuContext);
};
exports.useMenuContext = useMenuContext;
//# sourceMappingURL=MenuContext.js.map